module.exports = __webpack_public_path__ + "media/images/ic_name-6310700231d1b79b5ef10afd7448f1aa.svg";